export const categories = [
  'Living room',
  'Bathroom',
  'Kitchen',
  'Skin care',
  'Hair care',
  'Pets',
  'Jewelry',
  'Clothes',
];

export const EntityTypes = [
  'Registered Pty',
  'Sole proprietorship',
  'Close Corporation',
  'Limited liability company',
  'General partnership',
  'Limited partnership'
];

export const currencies = ['EUR', 'CHF', 'USD', 'GBP'];

export const distributionChannels = [
  'Customer',
  'B2B',
  'Drop Shipping',
  'Wholesale',
  'E-commerce',
  'Direct Sale',
];

export const dummyAcknowledgements = [
  { key: '001', value: 'I hereby acknowledge, that I have read and understood the conditions' },
  { key: '002', value: 'Sed diam nonumy eirmod tempor invidunt ut labore et dolore' },
  { key: '003', value: 'At vero eos et accusam et justo duo dolores et ea rebum' },
  { key: '004', value: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr' },
  {
    key: '005',
    value:
      'Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Nam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum.',
  },
]

export const AccountTypes = [
  { key: '001', value: 'Saving' },
  { key: '002', value: 'Cheque' },
]

export class DocumentTypes {  
  CopyOfRSAID : string = 'CopyOfRSAID';
  PhysicalAddressConfirmation : string = 'PhysicalAddressConfirmation';
  BankConfirmationLetter : string = 'BankConfirmationLetter';
  CompanyRegistrationDocuments : string = 'CompanyRegistrationDocuments';
  CopyOfDirectorsRSAIDorPassportDoc : string = 'CopyOfDirectorsRSAIDorPassportDoc';
  VatClearanceCertificate : string = 'VatClearanceCertificate';
  PhysicalAddressConfirmationViaUtilityBill : string = 'PhysicalAddressConfirmationViaUtilityBill';
  CompanyBankConfirmationLetter : string = 'CompanyBankConfirmationLetter';
}




